var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowcorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86354 3.06745L1.94687 9.00078C1.81354 9.13412 1.6551 9.20078 1.47154 9.20078C1.28799 9.20078 1.12976 9.13412 0.996875 9.00078C0.863541 8.86745 0.796875 8.70901 0.796875 8.52545C0.796875 8.34189 0.863541 8.18367 0.996875 8.05078L6.93021 2.13412H1.86354C1.67465 2.13412 1.51621 2.07012 1.38821 1.94212C1.26021 1.81412 1.19643 1.65589 1.19687 1.46745C1.19687 1.27856 1.26088 1.12012 1.38888 0.992117C1.51688 0.864117 1.6751 0.800339 1.86354 0.800784H8.53021C8.7191 0.800784 8.87754 0.864784 9.00554 0.992784C9.13354 1.12078 9.19732 1.27901 9.19688 1.46745V8.13412C9.19688 8.32301 9.13288 8.48145 9.00488 8.60945C8.87688 8.73745 8.71865 8.80123 8.53021 8.80078C8.34132 8.80078 8.18288 8.73678 8.05488 8.60878C7.92688 8.48078 7.8631 8.32256 7.86354 8.13412V3.06745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcorner);
export default __webpack_public_path__ + "static/media/arrowcorner.461dce553198fdfcc79f02f072b6c0b9.svg";
export { ForwardRef as ReactComponent };